import { BaseEventProps } from "@tvg/amplitude";

export type EventProps = BaseEventProps;

export enum MediatorEventType {
  LOGIN_WALL = "HEADER_LOGIN_WALL"
}
